"use client";

import { AssignDailyBonus200Response } from "@api/models";
import {
  sendActiveUserLog,
  sendClickLog,
  sendLoadPageLog,
  setCampaignRegisterCookie,
  updateRequestId,
} from "@lib/analyticLog";
import { closestElm } from "@lib/element";
import { logInfo } from "@lib/logger";
import { sessionStore } from "@lib/sessionStore";
import { getNextDayZeroDate } from "@lib/utils";
import { useToast } from "app/hooks";
import Cookies from "js-cookie";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect, useSyncExternalStore } from "react";

/*
分析ログ用コンポーネント
*/

export const LOG_UID_ELEMENT_ID = "xAnalyticLoggerUid";

const ACTIVE_USER_LOG_COOKIE_NAME = "log-active-sent";
export const GOT_LOGIN_BONUS_COOKIE_NAME = "got-bonus";

const onClick = (e: MouseEvent) => {
  const elm = closestElm(e.target as HTMLElement, "a,button");
  // data-log-click属性がセットされているもの＝収集対象
  if (elm && elm.hasAttribute("data-log-click")) {
    const params: { [key: string]: string } = {};
    const attributes = elm.attributes;
    for (const attr of attributes) {
      if (attr.name.indexOf("data-log-") === 0) {
        if (attr.name === "data-log-click") {
          continue;
        }
        params[attr.name.replace("data-log-", "").replace("-", "_")] = attr.value;
      }
    }
    sendClickLog(params);
  }
};

export function AnalyticLogger() {
  const pathName = usePathname();
  const query = useSearchParams();
  const { pushToast } = useToast();
  const { session, sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );

  useEffect(() => {
    if (sessionStatus === "authenticated") {
      //activeuserログ
      if (!Cookies.get(ACTIVE_USER_LOG_COOKIE_NAME)) {
        //ログの送信
        sendActiveUserLog(session?.user);
        Cookies.set(ACTIVE_USER_LOG_COOKIE_NAME, "1", { expires: getNextDayZeroDate() });
      }
    }
  }, [sessionStatus]);

  useEffect(() => {
    if (sessionStatus === "authenticated") {
      //ログインボーナス
      if (!Cookies.get(GOT_LOGIN_BONUS_COOKIE_NAME)) {
        fetch("/api/missions/assignDailyBonus", { next: { revalidate: 0 } })
          .then((res) => res.json())
          .then((res) => {
            const bonus = res.bonus as AssignDailyBonus200Response;
            if (bonus && bonus.bonusValue) {
              pushToast("ログインボーナス", { type: "bonus", bonusValue: bonus.bonusValue });
              Cookies.set(GOT_LOGIN_BONUS_COOKIE_NAME, "1", { expires: getNextDayZeroDate() });
            } else {
              logInfo("error:get login bonus");
            }
          })
          .catch(() => {
            logInfo("error:get login bonus network error");
          });
      }
    }
  }, [sessionStatus]);

  useEffect(() => {
    //URL変更時のイベント
    //request idを更新する
    updateRequestId();
    //loadpage
    sendLoadPageLog();
    //campaign
    setCampaignRegisterCookie(query);
  }, [pathName, query]);

  useEffect(() => {
    window.addEventListener("click", onClick);
    return () => {
      window.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <Suspense>
      <div id={LOG_UID_ELEMENT_ID} style={{ display: "none" }}>
        {/* ログ送信時用にHTML上でuser idにアクセス可能にしておく */}
        {session?.user}
      </div>
    </Suspense>
  );
}
